
import { PageManagerComponent } from './page-manager/page-manager.component';
import { LoginAuthGuard } from './Guards/login-auth.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingComponent } from './setting/setting.component';
const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  //  { path: 'dashboard',loadChildren: () => import('./WSCM-forms/WSCM-forms.module').then(m => m.FormsModule), canActivate: [LoginAuthGuard] },
  // { path: 'dashboard', component: DashboardComponent,canActivate: [LoginAuthGuard] },
  //{path: 'drag-and-drop', component: DragAndDropComponent, canActivate: [LoginAuthGuard] },
  { path: 'pages-manager', component: PageManagerComponent, canActivate: [LoginAuthGuard] },
  { path: 'settings', component: SettingComponent,canActivate: [LoginAuthGuard] },
  { path: 'content-manager', loadChildren: () => import('./core-content-manager/core-content-manager.module').then(m => m.CoreContentManagerModule), canActivate: [LoginAuthGuard]  },
  { path: 'page-manager', loadChildren: () => import('./page-manager/page-manager.module').then(m => m.PageManagerModule), canActivate: [LoginAuthGuard] },
  { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },


   {path:'**', redirectTo:'page-manager/pages', pathMatch:'full'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
